<template>
  <div class="wrapper" v-if="banner.length">
    <swiper :options="swiperOption" class="swiper-container">
      <!-- slides  -->
      <swiper-slide class="swiper-item" v-for="item of banner" :key="item.id">
        <img class="swiper-img" :src="item.pic" alt=""/>
      </swiper-slide>
      <!-- Optional controls ,显示小点 -->
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>

</template>

<script>
    export default {
      data() {
        return {
          banner: [
          ],
          swiperOption: {
            pagination: {
              el: ".swiper-pagination",
              clickable: true // 允许点击小圆点跳转
            },
            autoplay: {
              delay: 2500,
              stopOnLastSlide: false,
              disableOnInteraction: false
            }, //自动播放
            speed: 800, //滑动速度
            setWrapperSize: true,
            observeParents: true,
            paginationClickable: true, //点击分页器的指示点分页器控制Swiper切换
            loop: true, //循环
            observer: true,
            autoplayDisableOnInteraction: true, //用户操作swiper之后，是否禁止autoplay

          },
        }
      },
      methods:{
        async getbanner() {
          var dt = await this.$axios.get('/api/header')
          dt.data = JSON.parse(dt.data)
          if(dt.status == 200){
              if(dt.data.code !== 0){
                this.$message({
                    type: 'info',
                    message: dt.data.msg
                  });
                return;
              }
            }else{
              alert(dt.statusText)
              return;
            }
          // console.log(dt)
          this.banner=dt.data.data.banner
        }

      },
      created(){
         this.getbanner();
      },
      // mounted() {
      //    this.getbanner();
      // }

    }
</script>


<style lang="less" scoped>
.wrapper {
      padding: 0 !important;
      height: auto !important;
      .swiper-item img {
        width: 100%;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/pc/public/banner.vue